export const t = { "en": { "pricing-page-components": { "phone-support": { "seePhoneNumber": "See phone number" } } } };
export const d = [];